import api from './api';
import { handleAxiosError } from './ApiHelper';

export default class PaymentService {
    static async checkout(payload, navigate) {
        try {
            const res = await api.post('/api/payments/checkout', payload);
            return res.data;
        } catch (e) { return handleAxiosError(e, navigate); }
    }

    static async getTariffs(navigate) {
        try {
            const res = await api.get('/api/payments/tariffs');
            return res.data;
        } catch (e) { return handleAxiosError(e, navigate); }
    }

    static async getSubscription(navigate) {
        try {
            const res = await api.get('/api/payments/subscription');
            return res.data;
        } catch (e) { return handleAxiosError(e, navigate); }
    }

    static async getOrders({ page = 0, per_page = 20, type } = {}, navigate) {
        try {
            const res = await api.get('/api/payments/orders', { params: { page, per_page, type } });
            return res.data;
        } catch (e) { return handleAxiosError(e, navigate); }
    }
}
